"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DevNavigation = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("../theme/styled"));

var _reactRouterDom = require("react-router-dom");

var _Router = require("../Router");

var _context = require("../context");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  overflow: visible;\n  z-index: 10;\n"])));

var Select = _styled.default.select(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-radius: 0;\n  appearance: none;\n  width: 20px;\n  &:-moz-focusring {\n    color: transparent;\n    textshadow: 0 0 0 #000;\n  }\n  &:focus {\n    outline: 0;\n  }\n  opacity: ", ";\n  // background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"50\" viewBox=\"0 0 100 50\" fill=\"%23FF9900\"><polygon points=\"0,0 100,0 50,50\"/></svg>');\n"])), function (p) {
  return p.hide ? '0' : '1';
});

var Button = _styled.default.button(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  appearance: none;\n  border: 0;\n  &:focus {\n    outline: 0;\n  }\n  color: #ff9900;\n  background-color: transparent;\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"512\" viewBox=\"-2 0 511 512\" width=\"512\" fill=\"%23FF9900\"><path d=\"m500.628906 311.332031-27.960937-16.144531c-30.160157-17.414062-30.1875-60.949219 0-78.375l27.960937-16.144531c7.171875-4.144531 9.628906-13.316407 5.488282-20.488281l-60.242188-104.355469c-4.136719-7.167969-13.316406-9.632813-20.492188-5.492188l-27.960937 16.144531c-30.15625 17.410157-67.863281-4.324218-67.863281-39.1875v-32.289062c0-8.285156-6.714844-15-15-15h-120.488282c-8.28125 0-15 6.714844-15 15v32.289062c0 34.828126-37.671874 56.617188-67.863281 39.1875l-27.960937-16.144531c-7.167969-4.140625-16.347656-1.683593-20.492188 5.492188l-60.242187 104.355469c-4.140625 7.171874-1.683594 16.347656 5.488281 20.488281l27.960938 16.144531c30.160156 17.414062 30.1875 60.949219 0 78.375l-27.957032 16.144531c-7.175781 4.144531-9.632812 13.316407-5.492187 20.488281l60.242187 104.355469c4.136719 7.167969 13.316406 9.636719 20.492188 5.492188l27.960937-16.144531c30.152344-17.414063 67.863281 4.320312 67.863281 39.1875v32.289062c0 8.285156 6.714844 15 15 15h120.484376c8.285156 0 15-6.714844 15-15v-32.289062c0-34.820313 37.671874-56.621094 67.867187-39.1875l27.960937 16.144531c7.167969 4.140625 16.347657 1.683593 20.488282-5.492188l60.246094-104.355469c4.140624-7.171874 1.683593-16.34375-5.488282-20.488281zm-73.238281 96.855469-14.96875-8.644531c-50.160156-28.964844-112.863281 7.195312-112.863281 65.167969v17.289062h-90.488282v-17.289062c0-57.921876-62.664062-94.15625-112.863281-65.167969l-14.96875 8.644531-45.246093-78.375 14.96875-8.644531c50.15625-28.957031 50.207031-101.347657.003906-130.335938l-14.972656-8.644531 45.246093-78.375 14.96875 8.644531c50.160157 28.964844 112.863281-7.195312 112.863281-65.167969v-17.289062h90.488282v17.289062c0 57.921876 62.660156 94.15625 112.863281 65.167969l14.96875-8.644531 45.246094 78.375-14.96875 8.644531c-50.15625 28.957031-50.207031 101.347657-.003907 130.335938l14.972657 8.644531zm0 0\" /><path d=\"m254.316406 151c-57.894531 0-104.992187 47.101562-104.992187 105s47.097656 105 104.992187 105c57.890625 0 104.988282-47.101562 104.988282-105s-47.097657-105-104.988282-105zm0 180c-41.351562 0-74.992187-33.644531-74.992187-75s33.640625-75 74.992187-75c41.347656 0 74.988282 33.644531 74.988282 75s-33.640626 75-74.988282 75zm0 0\" /></svg>');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px 16px;\n"])));

var Path = _styled.default.span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-weight: 300;\n  text-align: right;\n  margin-right: 6px;\n  & > span {\n    color: grey;\n  }\n"])));

var DevNavigation = function DevNavigation(props) {
  var logAppState = props.logAppState;

  var _useContext = (0, _react.useContext)(_context.Context),
      state = _useContext.state;

  var history = (0, _reactRouterDom.useHistory)();

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  if (logAppState) {
    console.warn('********************');
    console.warn('APP STATE:', state);
    console.warn('********************');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var selectRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (selectRef.current) {
      selectRef.current.value = pathname;
    }
  }, [pathname, selectRef]);

  var handleOpenClick = function handleOpenClick() {
    setActive(true);
  };

  var handleOnChange = function handleOnChange(evt) {
    setActive(false);
    var value = evt.target.value;

    if (!value) {
      return;
    }

    history.push(value);
  };

  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Path, null, "Path: ", /*#__PURE__*/_react.default.createElement("span", null, pathname)), /*#__PURE__*/_react.default.createElement(Button, {
    onClick: handleOpenClick
  }), /*#__PURE__*/_react.default.createElement(Select, {
    onChange: handleOnChange,
    hide: !active,
    ref: selectRef
  }, _Router.router && _Router.router.map(function (option) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: option,
      value: option
    }, option === '/' ? 'INIT' : option.replace('/', '').toUpperCase());
  })));
};

exports.DevNavigation = DevNavigation;